import React, { useEffect } from "react";
import { FormGroup, ModalBody, ModalFooter } from "reactstrap";


const TnCForm = ({data}) => {

  const [htmlContent, setHtmlContent] = React.useState(
    "<p>Loading...</p>"
  );

  useEffect(() => {
     setHtmlContent(data?.termOfUse)
  }, [data?.termOfUse]);

  return (
    <>
      <form className="tablelist-form">
        <ModalBody>
          <div className="mb-3">
            <FormGroup className="mb-3">
            <div
            dangerouslySetInnerHTML={{ __html: htmlContent }}
            ></div>
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
          </div>
        </ModalFooter>
      </form>
    </>
  );
};

export default TnCForm;
